import CountUp from "react-countup";
import styles from "./renewStatus.module.scss"
import { RGN_TERM } from "../../constants/constants";
import { useState } from "react";

function BlockItem({ title, value, unit, img, deci = 1 }) {
	return (
		<div className={styles.item}>
			<div className={styles.item__img}>
				<img src={img} alt=""/>
			</div>
			<div className={styles.item__content}>
				<div className={styles.item__title}>{title}</div>
				<div className={styles.item__body}>
					<div>
						<span className={styles.item__value}>
							<CountUp end={value} separator="," duration={1.5} decimals={deci} redraw={true} />
						</span>
						<span className={styles.item__unit}>{unit}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

function Tooltip({ linkCnt, noLinkCnt, previousLinkCnt, previousNoLinkCnt}) {
    const linkDiff = linkCnt - previousLinkCnt;
    const noLinkDiff = noLinkCnt - previousNoLinkCnt;

	return (
		<div className={styles.tooltip}>
			<div className={styles.tooltip__content}>
				<div>한국에너지공단 보급사업 설비</div>
				<div>{noLinkCnt.toLocaleString()} 개</div>
                <div>
                    {noLinkDiff >= 0 ? '+' : ''}
                    {noLinkDiff.toLocaleString()} 개
                </div>
				<div>충남REMS 연동 설비</div>
				<div>{linkCnt.toLocaleString()} 개</div>
                <div>
                    {linkDiff >= 0 ? '+' : ''}
                    {linkDiff.toLocaleString()} 개
                </div>
			</div>
		</div>
	)
}

export default function RenewStatus({ top3EnsoStatDtoList, dashboardList, previousMonthCount, rgnCode, bizType }) {	
	const [tooltip, setTooltip] = useState(false);

	const formattedData = {
			totalCnt: top3EnsoStatDtoList?.reduce((sum, item) => sum + (item.cnt || 0), 0) || 0,
      dayPower: top3EnsoStatDtoList
        ?.filter(e => e.ensoTypeCode === 15001 || e.ensoTypeCode === 15004)
        .reduce((sum, e) => sum + (e.dayPower || 0), 0) || 0,
      dayUse: top3EnsoStatDtoList
        ?.filter(e => e.ensoTypeCode === 15002 || e.ensoTypeCode === 15003)
        .reduce((sum, e) => sum + (e.dayPower || 0), 0) || 0,
      carbDec: (top3EnsoStatDtoList?.reduce((sum, item) => sum + (item.dayPower || 0), 0) || 0) * 0.4653,
	}

	return (
		<div className={styles.block}>
			<div className={styles.block__head}>
				<div className={styles.block__title}>
					{rgnCode ? RGN_TERM[rgnCode] : "충남"}
				</div>
				<div className={styles.block__sub}>신재생 현황</div>				
				{bizType === 'bpm' && (
					<div className={styles.block__tooltip}>
						<svg
							width={20}
							height={20}
							aria-hidden="true"
							viewBox="0 0 24 24"
							onMouseEnter={() => setTooltip(true)}
							onMouseLeave={() => setTooltip(false)}
						>
							<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 17h-2v-2h2zm2.07-7.75-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25"></path>
						</svg>                  
						{tooltip && (
							<Tooltip
								linkCnt={dashboardList
									?.filter((rgn) => rgnCode === '' ? true : rgn.rgnCode === rgnCode)
									?.reduce((sum, item) => sum + (item.linkCnt || 0), 0) ?? '-'
								}
								noLinkCnt={dashboardList
									?.filter((rgn) => rgnCode === '' ? true : rgn.rgnCode === rgnCode)
									?.reduce((sum, item) => sum + (item.noLinkCnt || 0), 0) ?? '-'
								}
                				previousLinkCnt={previousMonthCount?.prevMonthlinkCnt ?? 0}
                				previousNoLinkCnt={previousMonthCount?.prevMonthNoLinkCnt ?? 0}
							/>
						)}
					</div>
				)}
			</div>

			<div className={styles.block__body}>
				<BlockItem
					img="/images/renewStat/renewStatus/meainCount.svg"					
					title="설비 개수"
					value={formattedData.totalCnt}
					unit='개'
					deci={0}
				/>
				<BlockItem
					img="/images/renewStat/renewStatus/ensoElec.svg"
					title="전기 에너지"
					value={formattedData.dayPower}
					unit='MWh'
				/>
				<BlockItem
					img="/images/renewStat/renewStatus/ensoHeat.svg"
					title="열에너지"
					value={formattedData.dayUse}
					unit='MWh'
				/>
				<BlockItem
					img="/images/renewStat/renewStatus/reduceCo2.svg"
					title="탄소저감량"
					value={formattedData.carbDec}
					unit='tCO₂'
				/>
			</div>
		</div>
	);
}